/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";

import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {                                   enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "| ABHISHEK KUMAR PATHAK |",
  title: "Namaste, I'm Abhishek",
  subTitle: emoji(
    "Senior iOS Engineer with 3.5+ years of experience architecting and delivering scalable mobile products in fintech and consumer ecosystems."
  ),
  resumeLink:
    "https://drive.google.com/file/d/13OfrwJm9DFsHV1W2Cg2TXkFyGvwoMBqJ/view?usp=sharing",
  displayGreeting: true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/AbhiPathaj",
  linkedin: "https://www.linkedin.com/in/abhishekpathak1003/",
  gmail: "abhishekpathak1003@gmail.com",
  //gitlab: "https://gitlab.com/saadpasta",
  //facebook: "https://www.facebook.com/saad.pasta7",
  //medium: "https://medium.com/@saadpasta",
  //stackoverflow: "https://stackoverflow.com/users/10422806/saad-pasta",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle:
    "SENIOR IOS ENGINEER SPECIALIZING IN SWIFT, ARCHITECTURE, CONCURRENCY, AND PAYMENTS",
  skills: [
    emoji(
      "⚡ Build scalable iOS products using Swift, UIKit, SwiftUI, and clean architecture patterns"
    ),
    emoji(
      "⚡ Architect payment and SDK platforms across native and hybrid ecosystems with reliability and compliance"
    ),
    emoji(
      "⚡ Deliver high-scale transaction journeys, international launches, and instrumentation with measurable business impact"
    )
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Swift, SwiftUI, UIKit",
      fontAwesomeClassname: "fab fa-swift"
    },
    {
      skillName: "Combine, CoreData, AutoLayout",
      fontAwesomeClassname: "fas fa-layer-group"
    },
    {
      skillName: "MVC, MVVM, Clean Architecture, DI",
      fontAwesomeClassname: "fas fa-sitemap"
    },
    {
      skillName: "XCTest, Unit Testing, UI Testing",
      fontAwesomeClassname: "fas fa-vial"
    },
    {
      skillName: "Git, CocoaPods, Fastlane, Firebase",
      fontAwesomeClassname: "fas fa-tools"
    },
    {
      skillName: "Fintech, UPI, System Design, Concurrency",
      fontAwesomeClassname: "fas fa-money-check-alt"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Delhi Technological University",
      //logo: require("./assets/images/harvardLogo.png"),
      subHeader: "B.Tech, Computer Science and Engineering",
      duration: "2018 – 2022 • CGPA: 8.1/10"

      //desc: "Participated in the research of XXX and published 3 papers.",
      /*descBullets: [
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit"
      ]*/
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "iOS / Swift", //Insert stack or technology you have experience in
      progressPercentage: "85%" //Insert relative proficiency in percentage
    },
    {
      Stack: "SDK & Framework Design",
      progressPercentage: "80%"
    },
    {
      Stack: "System Design & Architecture",
      progressPercentage: "70%"
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Senior iOS Engineer",
      company: "Paytm",
      companylogo: require("./assets/images/paytmLogo.png"),
      date: "June 2022 – Present",
      desc: "Senior iOS Engineer driving Paytm merchant and payments platform evolution across SDKs, compliance, UPI flows, and international rollout.",
      descBullets: [
        "Built native merchant apps for integrating AllinOneSDK, CustomUISDK, and RouterSDK, and enabled equivalent native SDK capabilities for Ionic Cordova, Ionic Capacitor, React Native, and Flutter hybrid apps.",
        "Partnered directly with merchants to resolve integration issues via calls and support, increasing SDK adoption by ~95%, improving merchant transactions by 500%, and contributing profit impact above 100M.",
        "Delivered accessibility improvements, payment-link redirections, and EMI feature support across Paytm payments journeys.",
        "Led Saved Cards Vault separation and TPAP RBI payment-aggregator compliance changes; played a major role in Paytm's UPI TPAP-model transition and frontend UPI revamp.",
        "Reduced compliance-related business impact by 60% through architecture and flow changes across intent, push, and collect UPI transaction paths.",
        "Built event logging for H5 and React surfaces embedded in native app journeys and supported merchant integrations, documentation, and issue ownership end to end.",
        "Led end-to-end Paytm Business iOS internationalization for Indonesia, including multi-environment build architecture, release management, and CI/CD-aligned configuration switching.",
        "Shipped Bahasa Indonesia localization across critical merchant flows and stabilized UAT-to-production launches with fixes across deep links, QR/share/download, auth edge cases, and cross-module regressions.",
        "Helped scale merchant and UPI funnel volume with impact across 100M+ transactions."
      ]
    },
    {
      role: "SDE Intern",
      company: "Chegg",
      companylogo: require("./assets/images/cheggLogo.png"),
      date: "Oct 2021 – Dec 2021",
      desc: "Contributed to product engineering for education workflows with a focus on delivery quality and cross-functional execution.",
      descBullets: [
        "Developed and tested software features to improve platform user experience.",
        "Collaborated with cross-functional teams to debug and resolve technical issues efficiently.",
        "Used version control workflows to manage code changes and streamline team delivery.",
        "Participated in code reviews and provided constructive feedback for maintainability and quality."
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "My Projects",
  subtitle: "A FEW PERSONAL IOS & ML PROJECTS",
  projects: [
    {
      animation: "tmdb",
      projectName: "TMDB iOS App",
      projectDesc:
        "A Netflix-style iOS client for TMDB with movie discovery, search, and detail pages powered by TMDB APIs.",
      footerLink: [
        {
          name: "View GitHub",
          url: "https://github.com/AbhiPathaj/TMDB-ios-App"
        }
      ]
    },
    {
      animation: "github",
      projectName: "GitHub Profile App",
      projectDesc:
        "A native iOS app to explore GitHub user profiles and data, built with Swift.",
      footerLink: [
        {
          name: "View GitHub",
          url: "https://github.com/AbhiPathaj/github/tree/main"
        }
      ]
    },
    {
      animation: "appleframeworks",
      projectName: "iOS Frameworks App",
      projectDesc:
        "An iOS app showcasing and experimenting with various native iOS frameworks.",
      footerLink: [
        {
          name: "View GitHub",
          url: "https://github.com/AbhiPathaj/IosFrameworksApp"
        }
      ]
    }
  ],
  display: true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle: "A few highlights from academics and competitive milestones.",
  achievementsCards: [
    {
      title: "12 Olympiad Gold Medals",
      subtitle:
        "Won 12 Olympiad golds across Mathematics, Physics, Astronomy, and Computer Science.",
      image: "https://via.placeholder.com/300x180.png?text=Olympiad+Golds",
      imageAlt: "Olympiad achievements",
      footerLink: [{name: "Achievement Highlight", url: ""}]
    },
    {
      title: "NDA Cleared",
      subtitle: "Successfully cleared NDA examination.",
      image: "https://via.placeholder.com/300x180.png?text=NDA",
      imageAlt: "NDA",
      footerLink: [{name: "Achievement Highlight", url: ""}]
    },
    {
      title: "JEE Mains & Advanced",
      subtitle: "Cleared JEE Mains and JEE Advanced; earned scholarships in 10th, 12th, and B.Tech.",
      image: "https://via.placeholder.com/300x180.png?text=JEE+and+Scholarships",
      imageAlt: "JEE and scholarships",
      footerLink: [{name: "Achievement Highlight", url: ""}]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

//Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [],
  display: false // Set false to hide this section, defaults to true
};

//Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",
  // ← add your link here:
  resumeLink:
    "https://drive.google.com/file/d/13OfrwJm9DFsHV1W2Cg2TXkFyGvwoMBqJ/view?usp=sharing",
  display: true
};
// … your existing socialMediaLinks above …

// Coding Profiles Section
const codingProfiles = {
  // set false to hide this section
  heading: "💻 Coding Profiles",
  subHeading: "Where I solve problems and grow my skills",
  profiles: [
    {
      platform: "LeetCode",
      url: "https://leetcode.com/u/AbhishekkumarPathak/",
      icon: "https://upload.wikimedia.org/wikipedia/commons/1/19/LeetCode_logo_black.png"
    },
    {
      platform: "GitHub",
      url: "https://github.com/AbhiPathaj",
      icon: "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png"
    }
  ],
  display: true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "New Delhi, India - Discuss a project or just want to say hi? My inbox is open for all.",
  number: "+91-9319773597",
  email_address: "abhishekpathak1003@gmail.com"
};
const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: true // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  codingProfiles,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
